'use strict';

function parts(instant, offsetMinutes) {
  const ms = new Date(instant).getTime();
  if (!Number.isFinite(ms) || !Number.isInteger(offsetMinutes) || Math.abs(offsetMinutes) > 840) throw Error('STORE_CIVIL_TIME_INVALID');
  const d = new Date(ms + offsetMinutes * 60000);
  const dateKey = `${d.getUTCFullYear()}-${String(d.getUTCMonth()+1).padStart(2,'0')}-${String(d.getUTCDate()).padStart(2,'0')}`;
  return { instantUtc: new Date(ms).toISOString(), offsetMinutes, dateKey, year:d.getUTCFullYear(), month:d.getUTCMonth(), day:d.getUTCDate(),
    dayOfWeek:d.getUTCDay(), hour:d.getUTCHours(), minute:d.getUTCMinutes(), second:d.getUTCSeconds(), millisecond:d.getUTCMilliseconds() };
}

// Compatibility view: getters are civil, the stored instant and ISO remain real.
class CivilDate extends Date {
  constructor(instant, offsetMinutes) { super(instant); parts(instant,offsetMinutes);this.offsetMinutes=offsetMinutes; }
  get civil(){return parts(super.getTime(),this.offsetMinutes);}
  getHours(){return this.civil.hour;} getMinutes(){return this.civil.minute;} getSeconds(){return this.civil.second;}
  getDay(){return this.civil.dayOfWeek;} getDate(){return this.civil.day;} getMonth(){return this.civil.month;} getFullYear(){return this.civil.year;}
  getTimezoneOffset(){return -this.civil.offsetMinutes;} toDateString(){return this.civil.dateKey;}
  setHours(...args){return this.setCivil('setUTCHours',args);} setMinutes(...args){return this.setCivil('setUTCMinutes',args);}
  setSeconds(...args){return this.setCivil('setUTCSeconds',args);} setMilliseconds(...args){return this.setCivil('setUTCMilliseconds',args);}
  setDate(...args){return this.setCivil('setUTCDate',args);} setMonth(...args){return this.setCivil('setUTCMonth',args);}
  setFullYear(...args){return this.setCivil('setUTCFullYear',args);}
  setCivil(method,args){const d=new Date(super.getTime()+this.offsetMinutes*60000);d[method](...args);return super.setTime(d.getTime()-this.offsetMinutes*60000);}
  toLocaleTimeString(locale,options={}){return new Date(super.getTime()+this.offsetMinutes*60000).toLocaleTimeString(locale,{...options,timeZone:'UTC'});}
  toLocaleDateString(locale,options={}){return new Date(super.getTime()+this.offsetMinutes*60000).toLocaleDateString(locale,{...options,timeZone:'UTC'});}
}

module.exports={parts,CivilDate};
